import type { Opportunity } from "../types";
import { useI18n } from "../lib/i18n";
import { statusLabel } from "../lib/status-labels";

export function OpportunityCard({
  opportunity,
  onUpdate,
  onHistory,
}: {
  opportunity: Opportunity;
  onUpdate: () => void;
  onHistory?: () => void;
}) {
  const { locale, t } = useI18n();
  const dateLocale = locale === "zh-CN" ? "zh-CN" : "en-GB";
  return (
    <article
      className={`opportunity-card ${opportunity.isOverdue ? "is-overdue" : ""}`}
    >
      <div className="card-heading">
        <div className="card-heading-copy">
          <span className="eyebrow">
            {opportunity.clientReference.displayName} ·{" "}
            {opportunity.clientReference.market}
          </span>
          <h3>{opportunity.projectName}</h3>
        </div>
        <span
          className={`status status-${opportunity.status.toLowerCase().replaceAll(" ", "-")}`}
        >
          {statusLabel(opportunity.status, locale)}
        </span>
      </div>
      <p>{opportunity.projectSummary}</p>
      <div className="card-meta">
        <div>
          <span>{t("nextCheckIn")}</span>
          <strong>
            {new Intl.DateTimeFormat(dateLocale, {
              month: "short",
              day: "numeric",
              year: "numeric",
            }).format(new Date(`${opportunity.nextCheckInOn}T00:00:00`))}
          </strong>
        </div>
        {opportunity.isOverdue && (
          <span className="overdue-pill">{t("overdue")}</span>
        )}
      </div>
      <div className={`card-actions ${onHistory ? "" : "single-action"}`}>
        {onHistory ? (
          <button
            className="secondary-button"
            type="button"
            onClick={onHistory}
          >
            {t("history")}
          </button>
        ) : null}
        <button className="primary-button" type="button" onClick={onUpdate}>
          {t("update")}
        </button>
      </div>
    </article>
  );
}
